const state = {
  user: null
};

const mutations = {
  SET_USER(state, user) {
    state.user = user;
  },
  CLEAR_USER(state) {
    state.user = null;
  },
};

const getters = {
  userRole: (state) => state.user?.roleId ?? 0,
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
};